import type { RouteObject } from "react-router-dom";
import RefundsPage, { refundsLoader } from "./Refunds";
import RefundDetailPage, { refundDetailLoader } from "./RefundDetail";
import TransactionsPage from "./Transactions";
import PaymentsList, { paymentsListLoader } from "./Payments";
import ReceiptsList, { receiptsListLoader } from "./Receipts";
import AppError from "../app-error";

export const financeRoutes: RouteObject[] = [
  { path: "finance/payments", Component: PaymentsList, loader: paymentsListLoader, errorElement: <AppError /> },
  { path: "finance/receipts", Component: ReceiptsList, loader: receiptsListLoader, errorElement: <AppError /> },
  { path: "finance/refunds", Component: RefundsPage, loader: refundsLoader, errorElement: <AppError /> },
  { path: "finance/refunds/:refundNumber", Component: RefundDetailPage, loader: refundDetailLoader, errorElement: <AppError /> },
  { path: "finance/transactions", Component: TransactionsPage, errorElement: <AppError /> },
];
